import { forceCacheClear } from './cacheManager';

/**
 * Force app update utility for critical fixes
 * This can be called when users report persistent issues
 */
export const forceAppUpdate = (): void => {
  console.log('Force app update triggered');
  
  // Show user a warning before clearing cache and reloading
  const userConfirmed = window.confirm(
    'This will refresh the app to ensure you have the latest version. ' +
    'You may need to log in again. Continue?'
  );
  
  if (userConfirmed) {
    forceCacheClear();
  }
};

// Make it globally available for debugging
(window as any).forceAppUpdate = forceAppUpdate;